import { render, staticRenderFns } from "./viewSUMUL.vue?vue&type=template&id=03132394&scoped=true"
import script from "./viewSUMUL.vue?vue&type=script&lang=js"
export * from "./viewSUMUL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03132394",
  null
  
)

export default component.exports